import { action, computed, observable } from 'mobx';
import { DateTime } from 'luxon';

import { BaseFormModel } from 'stores/BaseForm';
import { getDate, getLocalDateTime } from 'helpers/datetime';
import RootStore from 'stores/RootStore';
import { UserGroup } from 'stores/Staff/types';
import Log from 'helpers/log';
import { PromiseService } from 'services/PromiseService';
import httpFacade from 'http/httpFacade';
import { sortByAccessor } from 'helpers/accessors';
import { AccountantReportParams } from 'http/Api/employees';

class EmployeesAccountantForm extends BaseFormModel {
  @observable
  period: [DateTime, DateTime] = [getLocalDateTime(), getLocalDateTime()];

  @observable
  userGroupId = '';

  @observable private _userGroups: UserGroup[] = [];
  @observable private _promiseService = new PromiseService();

  @action.bound
  async init() {
    try {
      const { data } = await this._promiseService.add(
        httpFacade.staff.fetchUserGroups,
      );

      this._userGroups = data.content;
    } catch (error) {
      Log.info(error);
    }
  }

  @computed
  get reportRequestParams(): AccountantReportParams {
    return {
      from: getDate(this.period[0].toJSDate()),
      to: getDate(this.period[1].toJSDate()),
      userGroup: this.userGroupId,
    };
  }

  @computed
  get userGroupValues() {
    return [
      {
        value: '',
        label: RootStore.localization.formatMessage('title.all'),
      },
      ...this._userGroups
        .slice()
        .sort(sortByAccessor({ accessor: 'title', desc: false }))
        .map(group => ({
          value: group.id,
          label: group.title,
        })),
    ];
  }

  @computed
  get loading() {
    return this._promiseService.isPending || !this._promiseService.isCompleted;
  }
}

export default EmployeesAccountantForm;
